export default __webpack_public_path__ + "static/NeffSans-Regular-380c532c718e0e16029eaa508aa56949.woff2";